import { ThemeModule } from '../../front/lib/ThemeModule';
export class FaqList extends ThemeModule {
    constructor() {
        super(...arguments);
        this.entries = this.querySelectorAll('.faqListMod-entry').map((entryEl => {
            const questionEl = entryEl.querySelector('button.faqListMod-question');
            const answerEl = document.getElementById(questionEl === null || questionEl === void 0 ? void 0 : questionEl.getAttribute('aria-controls'));
            return {
                questionEl,
                answerEl,
                entryEl,
                slug: entryEl.id,
                answerContentEl: answerEl.querySelector('.richContent'),
            };
        }));
    }
    async init() {
        this.resolveLocationHash();
        window.addEventListener('hashchange', () => this.resolveLocationHash());
        this.entries.forEach(entry => {
            entry.questionEl.addEventListener('click', () => this.toggleEntry(entry));
        });
    }
    resolveLocationHash() {
        const slug = window.location.hash.substring(1);
        const entry = this.entries.find(entry => entry.slug === slug);
        if (entry) {
            this.setEntryActive(entry);
            window.scrollTo({
                top: entry.entryEl.offsetTop,
                behavior: 'smooth',
            });
        }
    }
    setEntryActive(entry) {
        entry.entryEl.classList.add('is--active');
        entry.questionEl.setAttribute('aria-expanded', 'true');
        entry.answerEl.style.height = entry.answerContentEl.scrollHeight + 'px';
    }
    setEntryInactive(entry) {
        entry.entryEl.classList.remove('is--active');
        entry.questionEl.setAttribute('aria-expanded', 'false');
        entry.answerEl.style.height = '';
    }
    isEntryActive(entry) {
        return entry.entryEl.classList.contains('is--active');
    }
    toggleEntry(entry) {
        if (this.isEntryActive(entry)) {
            this.setEntryInactive(entry);
        }
        else {
            this.setEntryActive(entry);
        }
    }
}
